import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { deleteBlog, getBlogs } from "./adminApi";

function formattedDate(value) {
  if (!value) return "-";

  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function AdminViewBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const filteredBlogs = useMemo(() => blogs, [blogs]);

  const loadBlogs = async (searchValue = "") => {
    setIsLoading(true);
    setError("");

    try {
      const response = await getBlogs(searchValue);
      setBlogs(response.blogs || []);
    } catch (error) {
      setError(error.message || "Unable to load blogs.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadBlogs();
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);
    loadBlogs(value);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this blog?")) return;

    try {
      await deleteBlog(id);
      setBlogs((items) => items.filter((blog) => blog.id !== id));
    } catch (error) {
      alert(error.message || "Unable to delete blog.");
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <p className="eyebrow">Content</p>
          <h2>View Blogs</h2>
        </div>
        <Link to="/admin/add-blog" className="admin-button secondary">
          Add Blog
        </Link>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <div>
            <p className="eyebrow">All posts</p>
            <h3>Blog library</h3>
          </div>
          <div className="table-actions">
            <input
              className="search-input"
              value={search}
              onChange={handleSearch}
              placeholder="Search blogs..."
              aria-label="Search blogs"
            />
          </div>
        </div>

        {error && <p className="auth-error">{error}</p>}

        <div className="table-scroll">
          <table className="admin-table admin-table-compact">
            <thead>
              <tr>
                <th>Image</th>
                <th>Blog Title</th>
                <th>Publish Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5">Loading blogs...</td>
                </tr>
              ) : filteredBlogs.length > 0 ? (
                filteredBlogs.map((blog) => (
                  <tr key={blog.id}>
                    <td>
                      <img className="table-thumb" src={blog.image_url} alt={blog.title} />
                    </td>
                    <td>{blog.title}</td>
                    <td>{formattedDate(blog.published_at || blog.created_at)}</td>
                    <td>
                      <span className={`status-badge ${blog.status.toLowerCase()}`}>
                        {blog.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          type="button"
                          className="icon-btn delete"
                          onClick={() => handleDelete(blog.id)}
                          aria-label={`Delete blog ${blog.title}`}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No blogs found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminViewBlogs;
